import { makeFetchActions } from 'utils/store';
import { PATH } from '../const';

const [actions, types] = makeFetchActions(PATH, {
  persist: true,
});

export { types };
export default actions;
